import {
  Avatar,
  Button,
  Divider,
  Grid,
  Typography,
  withStyles,
} from "@material-ui/core";
import { CLOSED, ONGOING } from "../../events/colors";
import React, { Fragment } from "react";

import ArrowRight from "@material-ui/icons/ChevronRight";
import GoToEventPageLink from "./GoToEventPageLink";
import classnames from "classnames";
import compose from "recompose/compose";
import { withTranslate } from "react-admin";

const Title = withStyles((theme) => ({
  legendContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  legendLabel: {
    display: "inline",
    marginLeft: theme.spacing.unit,
  },
  smallButton: {
    marginLeft: theme.spacing.unit * 2, // distanza extra dal testo
    padding: "2px 6px",
    minWidth: 32,
  },
  avatar: {
    height: 16,
    width: 16,
  },
  avatarOngoing: {
    backgroundColor: ONGOING,
  },
  avatarClosed: {
    backgroundColor: CLOSED,
  },
}))(({ classes, translate }) => (
  <Fragment>
    <Grid item lg={12} md={12} xs={12}>
      <Typography variant="title">
        {translate("dashboard.last_events")}
      </Typography>
      <Divider style={{ marginTop: 10 }} />
    </Grid>
    <Grid container item spacing={2} style={{ marginTop: 10 }}>
      {/* Eventi in corso + bottone */}
      <Grid item lg={4} md={6} xs={12} className={classes.legendContainer}>
        <Avatar className={classnames(classes.avatar, classes.avatarOngoing)} />
        <Typography className={classes.legendLabel}>
          {translate("website.event.ongoing")}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          className={classes.smallButton}
          style={{ borderColor: "red", color: "red" }}
          href={`#/event?filter=${encodeURIComponent(
            JSON.stringify({ is_ongoing: true, is_closed: false })
          )}`}
        >
          <ArrowRight fontSize="small" style={{ color: "red" }} />
        </Button>
      </Grid>

      {/* Eventi chiusi + bottone */}
      <Grid item lg={4} md={6} xs={12} className={classes.legendContainer}>
        <Avatar className={classnames(classes.avatar, classes.avatarClosed)} />
        <Typography className={classes.legendLabel}>
          {translate("website.event.closed")}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          className={classes.smallButton}
          style={{ borderColor: "red", color: "red" }}
          href={`#/event?filter=${encodeURIComponent(
            JSON.stringify({ is_ongoing: false, is_closed: true })
          )}`}
        >
          <ArrowRight fontSize="small" style={{ color: "red" }} />
        </Button>
      </Grid>

      {/* Pulsante "Lista Completa" */}
      <Grid
        item
        lg={4}
        md={12}
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <GoToEventPageLink />
      </Grid>
    </Grid>
  </Fragment>
));

export default compose(withTranslate)(Title);
